// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3l02W","inner":"Footer_inner__3jzle"};